<template>
  <v-btn
    :loading="$loading.isLoading('handleExport')"
    border
    color="white"
    density="comfortable"
    icon="mdi-light:printer"
    @click.stop="downloadPrintedForm">
  </v-btn>
</template>

<script lang="ts">
import { handleAsync } from 'best-modules/plugins'
import { download } from 'best-modules/vue-utils'
import { useRoute } from 'vue-router'
import { useCan } from '@/composables/useCan'
import { taskPrintedForm } from '@/requests/task'

type TaskPrintedFormType = 'incoming' | 'outgoing' | 'control' | 'observer'

export default {
  name: 'PrintedForm',
  setup() {
    const route = useRoute()
    const { can } = useCan()
    const getType = (): TaskPrintedFormType => {
      switch (route.name) {
        case 'incoming-tasks':
          return 'incoming'
        case 'outgoing-tasks':
          return 'outgoing'
        case 'control-tasks':
          return 'control'
        case 'observer-tasks':
          return 'observer'
        default:
          throw new Error('Task printed form - invalid route.name')
      }
    }
    const downloadPrintedForm = () => {
      can('tasks.print', () => {
        return handleAsync('handleExport', async () => {
          const data = await taskPrintedForm(getType())

          return download(data.url, 'report_task')
        })
      })
    }

    return { downloadPrintedForm }
  },
}
</script>

<style lang="scss" scoped></style>
